import { render, staticRenderFns } from "./LeftImage.vue?vue&type=template&id=21a1f888&scoped=true&"
import script from "./LeftImage.vue?vue&type=script&lang=js&"
export * from "./LeftImage.vue?vue&type=script&lang=js&"
import style0 from "./LeftImage.vue?vue&type=style&index=0&id=21a1f888&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a1f888",
  null
  
)

export default component.exports